<script>
    import { Statistic, initStatistic, Text, Icon } from "svantic";
    initStatistic()

    import {
        createBetWs
    } from "../../../../scripts/stake-api";

    let bet = { }



    export const placeBet =  async (...args) => {
        try {

             let r = await createBetWs(...args)
            if( r.data )
                bet =  r.data 
           
            return r
        } catch (e) {
            //any connection related error
            console.error("catch error fnc placeBet - e: ", e);
            return {error: e, data: null}
        }
        finally{

        }
    };
</script>

<Statistic size="huge" inverted>
    <Statistic.Value text={true}>
      
    </Statistic.Value>
    <Statistic.Label><Text class="medium">Tome of Life</Text></Statistic.Label>
</Statistic>

<style>
</style>
